import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";


// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//     authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//     appId: process.env.REACT_APP_FIREBASE_APP_ID,
// };

const firebaseConfig = {
    apiKey: "AIzaSyCYD8vfVRQ88dRAkTR5ZH_n20z2CfPdsYg",
    authDomain: "love-organised-life.firebaseapp.com",
    projectId: "love-organised-life",
    storageBucket: "love-organised-life.firebasestorage.app",
    messagingSenderId: "1016129428219",
    appId: "1:1016129428219:web:f29e0c7893cbe38ad96e5e"

};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);



export const requestPermissionAndGetToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            const currentToken = await getToken(messaging, {
                vapidKey: 'BN1CEynAiy7llDKxhK9oEZkfY0SBDM8Xydl0ofQzvSvjRS4YhAJIFkDq_dso7LqKcnED9MUyLSbdILdSoNJHbHU', // from Firebase Console
            });

            if (currentToken) {
                return currentToken;
            } else {
                console.warn('No registration token available.'); 
            }
        } else {
            console.warn('Notification permission not granted.');
        }
    } catch (err) {
           
    }

    return null;
};

export const removeToken = async () => {
    try {
        const success = await deleteToken(messaging);
        if (success) {
        }
    } catch (err) {
    }
};

// Foreground messages
export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
